import { toBoolean } from './common.helpers';

export function hasActiveTeamPlayCategories(
  categories: Array<{ isActive?: unknown }> | undefined,
): boolean {
  return Boolean(
    categories?.length && categories.some((c) => toBoolean(c?.isActive)),
  );
}

export function shouldShowTeamPlayGroupsSection(
  isTeamsClass: boolean,
  categories: Array<{ isActive?: unknown }> | undefined,
  existingGroupsCount: number,
): boolean {
  return (
    !isTeamsClass ||
    hasActiveTeamPlayCategories(categories) ||
    existingGroupsCount > 0
  );
}

export function canAddTeamPlayGroups(
  isTeamsClass: boolean,
  categories: Array<{ isActive?: unknown }> | undefined,
): boolean {
  return !isTeamsClass || hasActiveTeamPlayCategories(categories);
}
